namespace RioERP.Orders {
    export interface OrderProductBillingItemsTaxForm {
        OrderId: Serenity.LookupEditor;
        OrderProductsId: Serenity.LookupEditor;
        TaxTypeId: Serenity.LookupEditor;
        Rate: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        OrderProductBillingItemsId: Serenity.LookupEditor;
    }

    export class OrderProductBillingItemsTaxForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.OrderProductBillingItemsTax';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderProductBillingItemsTaxForm.init)  {
                OrderProductBillingItemsTaxForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.DecimalEditor;

                Q.initFormType(OrderProductBillingItemsTaxForm, [
                    'OrderId', w0,
                    'OrderProductsId', w0,
                    'TaxTypeId', w0,
                    'Rate', w1,
                    'TaxAmount', w1,
                    'OrderProductBillingItemsId', w0
                ]);
            }
        }
    }
}
